import React, { Component, useCallback, useEffect, useState } from 'react'
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from 'react-device-detect'
import './OnboardCard.sass'
import BiometricComponent from './BiometricComponent/BiometricComponent'
import SuccessHandler from './StatesComponents/SuccessHandler'
import ErrorHandler from './StatesComponents/ErrorHandler'
import LoadingHandler from './StatesComponents/LoadingHandler'
import MobileHandler from './StatesComponents/MobileHandler'
import ErrorCapHandler from './StatesComponents/ErrorCapHandler'
import ErrorGlassesHandler from './StatesComponents/ErrorGlassesHandler'
import ErrorInvalidHandler from './StatesComponents/ErrorInvalidHandler'
import HomeLoading from './homeLoading'
import UserSignup from '../User/UserSignup'

interface Props {
  token: (token: any) => void
}

function FaceOnboard({ token }: Props) {
  const [photoState, setphotoState] = useState<string>('')

  const handleResponse = useCallback((message: string) => {
    setphotoState(message)
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('fixBrowser')) {
      // setphotoState('mobile')
    }
  }, [])

  return (
    <>
      <div className={`${photoState} card proccess-card`}>
        {photoState === 'success' ? (
          <>
            <SuccessHandler />
          </>
        ) : photoState === 'error' ? (
          <ErrorHandler />
        ) : photoState === 'invalid' ? (
          <ErrorInvalidHandler onResponse={handleResponse} />
        ) : photoState === 'loading' ? (
          <LoadingHandler />
        ) : photoState === 'glasses' ? (
          <ErrorGlassesHandler onResponse={handleResponse} />
        ) : photoState === 'cap' ? (
          <LoadingHandler  />
        )  : photoState === 'rematch' ? (
          <UserSignup onResponse={handleResponse} />
        ) : isMobile || photoState === 'mobile' ? (
          <BiometricComponent
            token={token}
            onResponse={handleResponse}
          ></BiometricComponent>
        ) : (
          <BiometricComponent
            token={token}
            onResponse={handleResponse}
          ></BiometricComponent>
        )}
      </div>
    </>
  )
}

export default FaceOnboard
